import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
    Col,
    Row,
    Notification,
} from '@zillow/zrs-comet';
import { Text, Flex, Spacer } from '@zillow/constellation';

import LoadingConstants from 'app/shared/constants/LoadingConstants';
import BillingActions from 'app/shared/actions/BillingActions';
import numberUtils from 'app/shared/utils/numberUtils';

import { StyledDownloadButton } from './StyledComponents';

const propTypes = {
    data: PropTypes.array,
    selected: PropTypes.object,
};

const defaultProps = {
    data: [],
    selected: new Set(),
};

const notificationTypes = {
    [LoadingConstants.LOADING]: 'info',
    [LoadingConstants.SUCCESS]: 'success',
    [LoadingConstants.ERROR]: 'error',
};

const BillingTopBanner = ({
    dispatch,
    data,
    selected,
    downloadState,
    downloadErrorMessage,
}) => {
    const handleNotificationCloseClick = () => {
        dispatch(BillingActions.resetDownloadState());
    };
    const { size } = selected;
    React.useEffect(() => {
        if (size === 0) {
            handleNotificationCloseClick();
        }
    }, [selected]);
    if (data.length === 0) return null;
    const handleDownloadClick = () => {
        const invoiceNumbers = [];
        for (const i of selected) {
            invoiceNumbers.push(data[i].invoiceNumber);
        }
        dispatch(BillingActions.downloadInvoices(invoiceNumbers));
    };
    const getNotificationContent = (downloadState, downloadErrorMessage) => {
        switch (downloadState) {
            case LoadingConstants.LOADING:
                return 'Downloading invoice files...';
            case LoadingConstants.SUCCESS:
                return 'Download successful!';
            case LoadingConstants.ERROR:
                return downloadErrorMessage;
            default:
                return '';
        }
    };
    if (size === 0) {
        return (
            <Spacer marginY="lg" marginX="lg">
                <Text fontType="h6">Select invoices to download</Text>
            </Spacer>
        );
    }

    let invoiceAmount = 0;
    let invoiceBalance = 0;
    for (const i of selected) {
        invoiceAmount += data[i].amount;
        invoiceBalance += data[i].balance;
    }
    return (
        <Spacer marginY="lg" marginX="lg">
            {downloadState !== LoadingConstants.INITIAL && (
                <Notification
                    type={notificationTypes[downloadState]}
                    onClose={handleNotificationCloseClick}
                >
                    { getNotificationContent(downloadState, downloadErrorMessage)}
                </Notification>
            )}
            <div className="BillingTopBanner-invoice-count">
                <Row>
                    <Col xs={12} sm={4}>
                        <Flex display="flex" alignItems="center" as="div">
                            <Text fontType="h6">
                                {`${size} Invoice${size > 1 ? 's' : ''}`}
                            </Text>
                            <Spacer marginLeft="xs">
                                <StyledDownloadButton onClick={handleDownloadClick}>
                                    Download PDF
                                </StyledDownloadButton>
                            </Spacer>
                        </Flex>
                    </Col>
                </Row>
                {invoiceBalance > 0 && (
                    <Row>
                        <Col xs={12} md={4}>
                            <Spacer marginTop="sm">
                                <Flex display="flex" justifyContent="space-between">
                                    <span>INVOICE AMOUNT</span>
                                    {numberUtils.asCurrency(invoiceAmount, '$0,0.00')}
                                </Flex>
                                <Flex display="flex" justifyContent="space-between">
                                    <span>INVOICE BALANCE</span>
                                    {numberUtils.asCurrency(invoiceBalance, '$0,0.00')}
                                </Flex>
                            </Spacer>
                        </Col>
                    </Row>
                )}
            </div>
        </Spacer>
    );
};

const mapStateToProps = state => ({
    downloadState: state.billing.download.downloadState,
    downloadErrorMessage: state.billing.download.downloadErrorMessage,
});

BillingTopBanner.propTypes = propTypes;
BillingTopBanner.defaultProps = defaultProps;

export default connect(mapStateToProps)(BillingTopBanner);
